import React, { useRef, useState, useEffect } from "react";

const AudioPlayer = ({url}) => {
  const audioRef = useRef(null);
  const progressRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);


  useEffect(() => {
    console.log("Audio URL:", url);  // Log the URL to ensure it’s valid
  }, [url]);

  // Format time in minutes:seconds
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  // Toggle play/pause
  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (audio) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Update progress bar and current time
  const updateProgress = () => {
    const audio = audioRef.current;
    if (audio) {
      setCurrentTime(audio.currentTime);
      if (progressRef.current) {
        progressRef.current.style.width = `${(audio.currentTime / audio.duration) * 100}%`;
      }
    }
  };

  // Seek audio
  const seekAudio = (e) => {
    const progressContainer = e.currentTarget;
    const audio = audioRef.current;
    if (audio && progressContainer) {
      const rect = progressContainer.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const width = rect.width;
      const newTime = (clickX / width) * audio.duration;
      audio.currentTime = newTime;
    }
  };

  // Set audio duration on load
  const handleLoadedMetadata = () => {
    const audio = audioRef.current;
    if (audio) {
      setDuration(audio.duration);
    }
  };

  // Reset UI when audio ends
  const handleAudioEnd = () => {
    setIsPlaying(false);
    setCurrentTime(0);
    if (progressRef.current) {
      progressRef.current.style.width = "0%";
    }
  };

  return (
    <div className="audio-player">
      <button id="play-pause-btn" onClick={togglePlayPause}>
        {isPlaying ? 
                
                <img src='/icons/pause_record.png' className="w-[34px]"/>
                
                :  <img src='/icons/play.png' className="w-[34px]"/>}
      </button>
      <div
        className="progress-container"
        style={{
          width: "100%",
          height: "5px",
          background: "#ccc",
          position: "relative",
          cursor: "pointer",
        }}
        onClick={seekAudio}
      >
        <div
          ref={progressRef}
          className="progress-bar"
          style={{
            width: "0%",
            height: "100%",
            background: "#007bff",
          }}
        ></div>
      </div>
      <span id="time-display">
        {formatTime(currentTime)} / {formatTime(duration)}
      </span>
      <audio
        ref={audioRef}
        onTimeUpdate={updateProgress}
        onEnded={handleAudioEnd}
        onLoadedMetadata={handleLoadedMetadata}
      >
        <source
          src={url}
          type="audio/mpeg"
        />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default AudioPlayer;
